import React, { useState, useEffect } from "react";
import axios from "axios";
import schoolImage from "../images/school.jpg";
import classImage from "../images/class.jpg";
import proposalImage from "../images/abacusStudents.jpeg";
import Header from "./Header";
import Footer from "./Footer";
import { Constant } from "../helper/Constants";

export default function AbacusForSchools() {
  const [openModal, setOpenModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    schoolName: "",
    city: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("success");
  const [schoolData, setSchoolData] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setStatusMessage("");

    try {
      const payload = {
        contact_person_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        school_name: formData.schoolName,
        position: formData.city,
        message: formData.message,
      };

      const resp = await axios.post(Constant.postUrls.schoolEnquiry, payload);

      setStatusType("success");
      setStatusMessage(
        resp?.data?.message || "Your enquiry has been submitted successfully!",
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        schoolName: "",
        city: "",
        message: "",
      });

      setTimeout(() => {
        setOpenModal(false);
        setStatusMessage("");
      }, 1500);
    } catch (error) {
      setStatusType("error");
      setStatusMessage(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getSchoolData();
  }, []);
  const getSchoolData = async () => {
    try {
      axios.get(Constant.getUrls.getAbacusSchoolData).then((resp) => {
        console.log(resp);
        setSchoolData(resp.data.data[0]);
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Header />

      <div style={{ width: "100%", fontFamily: "Poppins, sans-serif" }}>
        {/* HERO */}
        <div
          style={{
            background: "#F2FAFF",
            padding: "60px 8%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 30,
            alignItems: "center",
          }}
        >
          <div style={{ width: isMobile ? "100%" : "50%" }}>
            <h1
              style={{
                fontSize: isMobile ? 30 : 42,
                color: "#ff6f6f",
                fontWeight: 700,
              }}
            >
              START ABACUS CLASSES <br /> IN YOUR SCHOOL
            </h1>

            <p style={{ fontSize: 18, maxWidth: 450 }}>
              A Budget-Friendly Abacus Program Exclusively Designed For Your
              School
            </p>

            <button
              onClick={() => setOpenModal(true)}
              style={{
                marginTop: 25,
                padding: "14px 32px",
                background: "#ff6f6f",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              Enquiry Now
            </button>
          </div>

          <img
            src={schoolImage}
            alt="school"
            style={{
              width: isMobile ? "100%" : 420,
              maxWidth: "100%",
            }}
          />
        </div>

        {/* IMAGE + TEXT */}
        <div
          style={{
            padding: "60px 8%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "4%",
          }}
        >
          <img
            src={classImage}
            style={{
              width: isMobile ? "100%" : "48%",
              borderRadius: 6,
            }}
          />

          <div style={{ width: isMobile ? "100%" : "48%" }}>
            <h2 style={{ fontSize: 34 }}>
              WHY ABACUS <span style={{ color: "#ff6f6f" }}>FOR SCHOOL?</span>
            </h2>

            <div
              className="about-para"
              dangerouslySetInnerHTML={{
                __html: schoolData?.abacus_school_description,
              }}
            />

            {/* <p style={{ lineHeight: "28px" }}>
              Why Abacus for School? It is a unique program offering lifetime
              skills and developing <b>Mental Math</b> abilities.
            </p> */}
          </div>
        </div>

        {/* PROPOSAL */}
        <div style={{ padding: "60px 8%", background: "#F5F5F5" }}>
          <div style={{ background: "#fff", borderRadius: 10, padding: 40 }}>
            <h2 style={{ textAlign: "center", fontSize: 36 }}>
              VASA-ABACUS{" "}
              <span style={{ color: "#ff6f6f" }}>SCHOOL PROPOSAL</span>
            </h2>

            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "4%",
                marginTop: 30,
              }}
            >
              <img
                src={proposalImage}
                style={{
                  width: isMobile ? "100%" : "45%",
                  borderRadius: 8,
                }}
              />

              <div style={{ width: isMobile ? "100%" : "51%" }}>
                <h3 style={{ color: "#ff6f6f" }}>OFFLINE CLASSES</h3>
                <ol style={{ lineHeight: "28px" }}>
                  {schoolData?.abacus_proposal_description?.length > 0 &&
                    schoolData?.abacus_proposal_description?.map((item) => (
                      <li>{item}</li>
                    ))}
                  {/* <li>Teachers Training to nominated teachers</li>
                  <li>Training Kit & Students books</li>
                  <li>Certification at every level</li>
                  <li>Students App</li>
                  <li>Training portal access</li>
                  <li>Unlimited practice sheets</li>
                  <li>School decides fee / value addition</li> */}
                </ol>

                <button
                  onClick={() => setOpenModal(true)}
                  style={{
                    marginTop: 20,
                    padding: "14px 32px",
                    background: "#ff6f6f",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Enquiry Now
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ADVANTAGES */}
        <div style={{ padding: "80px 8%", textAlign: "center" }}>
          <h2 style={{ fontSize: 36 }}>
            ADVANTAGES -{" "}
            <span style={{ color: "#ff6f6f" }}>IMPLEMENTATION</span> OF ABACUS
            FOR SCHOOL
          </h2>

          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 20,
              marginTop: 50,
            }}
          >
            {[
              "Improved performance in academics",
              "Improved performance in Maths by Abacus Students",
              "Value addition to school Curriculum",
              "No additional investment for Abacus Classes",
            ].map((t, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  background: ["#FFFFE0", "#FFEDEA", "#EFFFFF", "#F4EDFF"][i],
                  padding: "40px 20px",
                  borderRadius: 10,
                }}
              >
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ================= MODAL (UNCHANGED UI) ================= */}
      {openModal && (
        <div
          onClick={() => setOpenModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: isMobile ? "90%" : 420,
              background: "#fff",
              borderRadius: 10,
              padding: 30,
              position: "relative",
            }}
          >
            <span
              onClick={() => setOpenModal(false)}
              style={{
                position: "absolute",
                right: 15,
                top: 10,
                fontSize: 22,
                cursor: "pointer",
              }}
            >
              ×
            </span>

            <h3 style={{ marginBottom: 20 }}>SCHOOL INQUIRY</h3>

            <input
              name="name"
              placeholder="Enter Name"
              value={formData.name}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              name="email"
              placeholder="Enter Email Id"
              value={formData.email}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              name="phone"
              placeholder="Enter Contact No"
              value={formData.phone}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              name="schoolName"
              placeholder="Enter School Name"
              value={formData.schoolName}
              onChange={handleChange}
              style={inputStyle}
            />
            <input
              name="city"
              placeholder="Enter Position"
              value={formData.city}
              onChange={handleChange}
              style={inputStyle}
            />

            <textarea
              name="message"
              placeholder="Your Remarks / Comments"
              value={formData.message}
              onChange={handleChange}
              style={{ ...inputStyle, height: 80 }}
            />

            {statusMessage && (
              <p style={{ color: statusType === "success" ? "green" : "red" }}>
                {statusMessage}
              </p>
            )}

            <button
              onClick={handleSubmit}
              disabled={submitting}
              style={{
                width: "100%",
                padding: "14px",
                background: "#ff6f6f",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              {submitting ? "Submitting..." : "SUBMIT"}
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

const inputStyle = {
  width: "100%",
  marginBottom: 15,
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: 4,
};
